export default __webpack_public_path__ + "static/media/anshul.97852f42.png";